import React from 'react';
import { Disclaimer } from './LegalContent';

function DisclaimerPage() {
  return (
    <div className="support-page">
      <Disclaimer />
    </div>
  );
}

export default DisclaimerPage;
